import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a07d45aa"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "dashboard" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "dashboard__header" }, [
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createElementVNode("div", { class: "dashboard__title" }, "Dashboard"),
    /*#__PURE__*/_createElementVNode("div", { class: "dashboard__subtitle" }, " Tổng quan thiết bị & thống kê 12 tháng ")
  ])
], -1))
const _hoisted_3 = { class: "kpi-grid" }
const _hoisted_4 = { class: "kpi-card indigo" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "kpi-title" }, "Tổng thiết bị", -1))
const _hoisted_6 = { class: "kpi-value" }
const _hoisted_7 = { class: "kpi-card green" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "kpi-title" }, "Tiếp nhận", -1))
const _hoisted_9 = { class: "kpi-value" }
const _hoisted_10 = { class: "kpi-card amber" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "kpi-title" }, "Hết hạn", -1))
const _hoisted_12 = { class: "kpi-value" }
const _hoisted_13 = { class: "kpi-card red" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "kpi-title" }, "Thanh lý", -1))
const _hoisted_15 = { class: "kpi-value" }
const _hoisted_16 = { class: "dashboard__grid" }
const _hoisted_17 = { class: "chart-card" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "chart-title" }, "Thiết bị theo khoa", -1))
const _hoisted_19 = { class: "chart-card" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "chart-title" }, "Tiếp nhận & hết hạn", -1))
const _hoisted_21 = { class: "chart-card wide" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "chart-title" }, "Xu hướng 12 tháng", -1))
const _hoisted_23 = { class: "chart-card" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "chart-title" }, "Tiếp nhận theo khoa", -1))

import { ref, computed } from "vue";
import QLTSRepository from "@/services/QLTSRepository";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const listThongKeTiepNhanTrongNam = ref([]);
const listThongKeHetHanTrongNam = ref([]);
const tongHop = ref([]);
const listThongKeKhoaTrongNam = ref([]);
const listThongKeHienCo = ref([]);

QLTSRepository.getListThongKeTheoKhoaTrong12Thang().then(r => listThongKeKhoaTrongNam.value = r.data);
QLTSRepository.getListThongKeThietBiHienCo().then(r => listThongKeHienCo.value = r.data);
QLTSRepository.getListSoLuongTiepNhanTrong12Thang().then(r => listThongKeTiepNhanTrongNam.value = r.data);
QLTSRepository.getListSoLuongQuaHanTrong12Thang().then(r => listThongKeHetHanTrongNam.value = r.data);
QLTSRepository.getListThongKeTrong12Thang().then(r => tongHop.value = r.data);

function generateColors(count: number): string[] {
  const base = [
    "#6366F1","#22C55E","#06B6D4","#F59E0B","#EF4444",
    "#8B5CF6","#14B8A6","#F43F5E","#0EA5E9","#84CC16"
  ];

  if (count <= base.length) return base.slice(0, count);

  return Array.from({ length: count }, (_, i) => {
    const hue = (i * 137.508) % 360;
    return `hsl(${hue}, 72%, 50%)`;
  });
}

/* KPI */
const totalDevices = computed(() =>
    listThongKeHienCo.value.reduce((a,b)=>a+b.soLuong,0)
);
const totalTiepNhan = computed(() =>
    tongHop.value.reduce((a,b)=>a+b.soLuongTiepNhan,0)
);
const totalHetHan = computed(() =>
    tongHop.value.reduce((a,b)=>a+b.soLuongHetHan,0)
);
const totalThanhLy = computed(() =>
    tongHop.value.reduce((a,b)=>a+b.soLuongThanhLy,0)
);

/* PIE */
const chartAllOptions = computed(() => ({
  labels: listThongKeHienCo.value.map(x => x.ten),
  colors: generateColors(listThongKeHienCo.value.length),
  fill: { type: "solid" },
  stroke: { width: 2, colors: ["#fff"] },
  legend: {
    position: "right",
    fontSize: "13px",
    labels: { colors: "#334155" }
  },
  states: {
    hover: { filter: { type: "lighten", value: 0.08 }},
    active: { filter: { type: "darken", value: 0.2 }}
  }
}));
const AllSeries = computed(()=> listThongKeHienCo.value.map(x=>x.soLuong));

const chartOptions = computed(()=>({
  chart:{toolbar:{show:false}},
  colors:["#6366F1","#F59E0B"],
  plotOptions:{bar:{borderRadius:12,columnWidth:"45%"}},
  fill:{
    type:"gradient",
    gradient:{
      opacityFrom:1,
      opacityTo:0.7
    }
  },
  dataLabels:{enabled:false},
  grid:{strokeDashArray:4},
  xaxis:{categories:listThongKeTiepNhanTrongNam.value.map(x=>x.ten)}
}));

const series = computed(()=>[
  {name:"Tiếp nhận",data:listThongKeTiepNhanTrongNam.value.map(x=>x.soLuong)},
  {name:"Hết hạn",data:listThongKeHetHanTrongNam.value.map(x=>x.soLuong)}
]);

const optionsYear = computed(()=>({
  chart:{toolbar:{show:false}},
  colors:["#6366F1","#22C55E","#94A3B8"],
  stroke:{curve:"smooth",width:3},
  fill:{
    type:"gradient",
    gradient:{
      opacityFrom:0.5,
      opacityTo:0.05
    }
  },
  dataLabels:{enabled:false},
  grid:{strokeDashArray:4},
  xaxis:{categories:tongHop.value.map(x=>x.ten)}
}));

const seriesYear = computed(()=>[
  {name:"Tiếp nhận",data:tongHop.value.map(x=>x.soLuongTiepNhan)},
  {name:"Hết hạn",data:tongHop.value.map(x=>x.soLuongHetHan)},
  {name:"Thanh lý",data:tongHop.value.map(x=>x.soLuongThanhLy)}
]);

const chartDepartmentsOptions = computed(() => ({
  labels: listThongKeKhoaTrongNam.value.map(x => x.ten),
  colors: generateColors(listThongKeKhoaTrongNam.value.length),
  fill: { type: "solid" },
  stroke: { width: 2, colors: ["#fff"] },
  legend: {
    position: "bottom",
    fontSize: "13px",
    labels: { colors: "#334155" }
  },
  plotOptions: {
    pie: {
      donut: {
        size: "72%",
        labels: {
          show: true,
          value: {
            fontSize: "22px",
            fontWeight: 700,
            color: "#0f172a"
          },
          total: {
            show: true,
            label: "Tổng",
            color: "#94a3b8",
            formatter: (w:any)=>
                w.globals.seriesTotals.reduce((a:number,b:number)=>a+b,0)
          }
        }
      }
    }
  }
}));
const departmentsSeries = computed(()=> listThongKeKhoaTrongNam.value.map(x=>x.soLuong));

return (_ctx: any,_cache: any) => {
  const _component_apexchart = _resolveComponent("apexchart")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _createElementVNode("div", _hoisted_6, _toDisplayString(_unref(totalDevices)), 1)
      ]),
      _createElementVNode("div", _hoisted_7, [
        _hoisted_8,
        _createElementVNode("div", _hoisted_9, _toDisplayString(_unref(totalTiepNhan)), 1)
      ]),
      _createElementVNode("div", _hoisted_10, [
        _hoisted_11,
        _createElementVNode("div", _hoisted_12, _toDisplayString(_unref(totalHetHan)), 1)
      ]),
      _createElementVNode("div", _hoisted_13, [
        _hoisted_14,
        _createElementVNode("div", _hoisted_15, _toDisplayString(_unref(totalThanhLy)), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_16, [
      _createElementVNode("div", _hoisted_17, [
        _hoisted_18,
        _createVNode(_component_apexchart, {
          type: "pie",
          height: "300",
          options: _unref(chartAllOptions),
          series: _unref(AllSeries)
        }, null, 8, ["options", "series"])
      ]),
      _createElementVNode("div", _hoisted_19, [
        _hoisted_20,
        _createVNode(_component_apexchart, {
          type: "bar",
          height: "300",
          options: _unref(chartOptions),
          series: _unref(series)
        }, null, 8, ["options", "series"])
      ]),
      _createElementVNode("div", _hoisted_21, [
        _hoisted_22,
        _createVNode(_component_apexchart, {
          type: "area",
          height: "300",
          options: _unref(optionsYear),
          series: _unref(seriesYear)
        }, null, 8, ["options", "series"])
      ]),
      _createElementVNode("div", _hoisted_23, [
        _hoisted_24,
        _createVNode(_component_apexchart, {
          type: "donut",
          height: "300",
          options: _unref(chartDepartmentsOptions),
          series: _unref(departmentsSeries)
        }, null, 8, ["options", "series"])
      ])
    ])
  ]))
}
}

})